import React, { useEffect, useState, useCallback } from 'react';
import { Shield, ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';

export const AdminUsersPage = () => {
  const { axiosInstance, user: currentUser } = useAuth();
  const [users, setUsers] = useState([]);

  const fetch = useCallback(async () => {
    const res = await axiosInstance.get('/admin/users');
    setUsers(res.data);
  }, [axiosInstance]);

  useEffect(() => { fetch(); }, [fetch]);

  const toggleRole = async (u) => {
    const newRole = u.role === 'admin' ? 'user' : 'admin';
    if (!window.confirm(`Définir ${u.name} comme ${newRole === 'admin' ? 'administrateur' : 'utilisateur standard'} ?`)) return;
    try {
      await axiosInstance.patch(`/admin/users/${u.user_id}/role`, null, { params: { role: newRole } });
      toast.success('Rôle mis à jour');
      fetch();
    } catch {
      toast.error('Erreur');
    }
  };

  return (
    <div data-testid="admin-users">
      <h1 className="font-heading text-3xl font-bold text-[#3E2723]">Utilisateurs</h1>
      <p className="text-[#6D4C41] mt-1 mb-6">{users.length} compte(s)</p>

      <div className="bg-white rounded-2xl border border-[#D4C4AA]/40 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F5EFE3] text-[#6D4C41]">
            <tr>
              <th className="text-left px-4 py-3 font-medium">Nom</th>
              <th className="text-left px-4 py-3 font-medium">Email</th>
              <th className="text-left px-4 py-3 font-medium">Téléphone</th>
              <th className="text-left px-4 py-3 font-medium">Commandes</th>
              <th className="text-left px-4 py-3 font-medium">Fidélité</th>
              <th className="text-left px-4 py-3 font-medium">Rôle</th>
              <th className="text-right px-4 py-3 font-medium">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.user_id} className="border-t border-[#F5EFE3]" data-testid={`admin-user-${u.user_id}`}>
                <td className="px-4 py-3 font-medium text-[#3E2723]">{u.name}</td>
                <td className="px-4 py-3 text-[#6D4C41]">{u.email}</td>
                <td className="px-4 py-3 text-[#6D4C41]">{u.phone || '—'}</td>
                <td className="px-4 py-3 text-[#3E2723]">{u.orders_count}</td>
                <td className="px-4 py-3 text-[#3E2723]">{u.loyalty_points || 0} pts</td>
                <td className="px-4 py-3">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${u.role === 'admin' ? 'bg-[#D4A373] text-[#3E2723]' : 'bg-[#F5EFE3] text-[#6D4C41]'}`}>
                    {u.role === 'admin' ? 'Admin' : 'Utilisateur'}
                  </span>
                </td>
                <td className="px-4 py-3 text-right">
                  {u.user_id !== currentUser?.user_id && (
                    <button
                      onClick={() => toggleRole(u)}
                      className="inline-flex items-center gap-1 px-2 py-1 text-xs rounded hover:bg-[#F5EFE3] text-[#3E2723]"
                      data-testid={`admin-toggle-role-${u.user_id}`}
                    >
                      {u.role === 'admin' ? <Shield size={14} /> : <ShieldCheck size={14} />}
                      {u.role === 'admin' ? 'Rétrograder' : 'Promouvoir'}
                    </button>
                  )}
                </td>
              </tr>
            ))}
            {users.length === 0 && (
              <tr><td colSpan={7} className="px-4 py-8 text-center text-[#6D4C41]/60">Aucun utilisateur</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
